const Padding = ({padding})=> {
    const pad = padding || "mt-5"
    return (
        <div className={pad}>

        </div>
    )
}

export default Padding